<template>
  <div class="mgx_set_container">
    <div class="mgx_set_box">
      <div class="mgx_key_group_float" v-if="!IMCSwitchState && isFE87V2IMCNH() == false">
        <mgx_key_group />
      </div>
      <div class="mgx_new_header">
        <div class="mgx_support_group">
          <IMCSwitch v-if="specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)"></IMCSwitch>

          <template v-if="currentMgxMode == MgxMode.MGX">
            <div ref="calibrationTipButtonRef" class="mgx_tip_btn" v-if="isShowCalibration" @click="calibrationEvent" @mouseenter="showCalibrationTooltip" @mouseleave="hideCalibrationTooltip">
              <div class="icon-wrapper">
                <SvgAsset :content="mgxCalibrationSvg" />
              </div>
              <!-- {{ calibrationHandler.isWitmodVendor() ? $t('key_calibration') : $t('key_calibration_trave') }} -->
              {{ $t('key_calibration') }}
            </div>
            <div class="mgx_tip_btn" @click="isShowTester = true">
              <div class="icon-wrapper">
                <SvgAsset :content="mgxTesterSvg" />
              </div>
              {{ $t('key_tester') }}
            </div>
            <div v-if="isSupportKeyGroupSettings" class="mgx_tip_btn" @click="selectSwitch">
              <div class="icon-wrapper">
                <SvgAsset :content="mgxSelectSwitchSvg" />
              </div>
              {{ $t('magnet_select_switch') }}
            </div>
            <!-- <div class="mgx_tip_btn" @click="open">
            <div class="icon-wrapper">
              <SvgAsset :content="mgxHelpCircleSvg" />
            </div>
            {{ $t('magnet_set_trigger_trip_introduce') }}
          </div> -->
          </template>
        </div>
        <div class="mgx_btn_group" v-if="currentMgxMode == MgxMode.MGX">
          <div class="mgx_action_btn" :class="{ disable: setkeyDisable, is_loading: resetStatus === 'loading', is_success: resetStatus === 'success', is_error: resetStatus === 'error' }" @click="reset(magnetSet.selectedKeys.value.length == 0)">
            <div class="btn-content-fade" :key="resetStatus">
              <div class="icon-wrapper" v-if="resetStatus === 'idle'" style="color: var(--color-text-hint)">
                <SvgAsset :content="mgxResetSvg" />
              </div>
              <div class="icon-wrapper" v-else-if="resetStatus === 'loading'">
                <SvgAsset :content="mgxLoadingSvg" />
              </div>
              <div class="icon-wrapper" v-else-if="resetStatus === 'success'">
                <SvgAsset :content="mgxSuccessSvg" />
              </div>
              <div class="icon-wrapper" v-else-if="resetStatus === 'error'">
                <SvgAsset :content="mgxErrorSvg" />
              </div>
              <span v-if="resetStatus === 'idle'" style="color: var(--color-text-hint)">{{ magnetSet.selectedKeys.value.length == 0 ? $t('magnet_reset_all_keys') : $t('magnet_reset_keys') }}</span>
            </div>
          </div>
          <div class="mgx_action_btn primary" :class="{ disable: setkeyDisable, is_loading: saveStatus === 'loading', is_success: saveStatus === 'success', is_error: saveStatus === 'error' }" @click="save">
            <div class="btn-content-fade" :key="saveStatus">
              <div class="icon-wrapper" v-if="saveStatus === 'idle'">
                <SvgAsset :content="mgxSaveSvg" />
              </div>
              <div class="icon-wrapper" v-else-if="saveStatus === 'loading'">
                <SvgAsset :content="mgxLoadingSvg" />
              </div>
              <div class="icon-wrapper" v-else-if="saveStatus === 'success'">
                <SvgAsset :content="mgxSuccessSvg" />
              </div>
              <div class="icon-wrapper" v-else-if="saveStatus === 'error'">
                <SvgAsset :content="mgxErrorSvg" />
              </div>
              <span v-if="saveStatus === 'idle'">{{ $t('save') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="mgx_set_box_content" v-if="currentMgxMode == MgxMode.MGX">
        <div class="mgx_travel_tip" v-if="isSupportKeyGroupSettings && isShowMoreGroupBottomTravelTip">
          <SvgAsset :content="mgxInfoCircleSvg" />
          <span>{{ $t('mgx_quick_trigger_release_num_tip') }}</span>
        </div>

        <div class="mgx_visual_panel">
          <!-- Bar 1: Press (Orange) -->
          <div class="mgx_bar_item orange" @mouseenter="currentHoveredKey = 'pressNum'">
            <div v-if="magnetSet.selectedKeys.value.length == 0" class="progress_overlay" @mousedown="selectCheck(true)" style="position: absolute; inset: 0; z-index: 100; cursor: pointer"></div>
            <div class="visual_wrapper">
              <div class="bar_track">
                <div class="bar_fill orange" :style="{ height: getAdaptiveFillHeight(pressNum, getBoundary('press', 'min'), getBoundary('press', 'max')) }"></div>
              </div>
              <input
                v-model.number="pressNum"
                class="trip_range orange_thumb"
                style="transform: translate(-50%, -50%) rotate(90deg)"
                type="range"
                :min="getBoundary('press', 'min')"
                :step="getBoundary('press', 'step')"
                :max="travelconfig.maxTravel"
                @wheel="wheelEvent($event, 'pressNum')"
                @input="changePressNum"
              />
            </div>
            <div class="bar_label_group">
              <div class="bar_label">{{ $t('magnet_set_trigger_trip') }}</div>
              <div class="bar_sub_label"><input v-model="pressNumMM" maxlength="8" @blur="travelInputOnBlur($event, 'pressNumMM')" @input="travelInputOnInput($event, 'pressNumMM')" @keydown.enter="($event.target as HTMLInputElement).blur()" />mm</div>
            </div>
          </div>

          <!-- Bar 2: RT Reset (Blue) -->
          <div class="mgx_bar_item blue" v-if="!specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)" @mouseenter="currentHoveredKey = 'quickTriggerReleaseNum'">
            <div v-if="magnetSet.selectedKeys.value.length == 0" class="progress_overlay" @mousedown="selectCheck(true)" style="position: absolute; inset: 0; z-index: 100; cursor: pointer"></div>
            <div class="visual_wrapper">
              <div class="bar_track">
                <div
                  class="bar_fill blue"
                  :style="{
                    height: quickTriggerReleaseNum > 0 ? getAdaptiveFillHeight(quickTriggerReleaseNum, getBoundary('rtRelease', 'min'), getBoundary('rtRelease', 'max')) : '0',
                  }"
                ></div>
              </div>
              <input
                v-model.number="quickTriggerReleaseNum"
                class="trip_range blue_thumb"
                style="transform: translate(-50%, -50%) rotate(-90deg)"
                type="range"
                :min="getBoundary('rtRelease', 'min')"
                :step="getBoundary('rtRelease', 'step')"
                :max="getBoundary('rtRelease', 'max')"
                @wheel="wheelEvent($event, 'quickTriggerReleaseNum')"
              />
            </div>
            <div class="bar_label_group">
              <div class="bar_label">{{ $t('magnet_quick_reset_sensitivity') }}</div>
              <div class="bar_sub_label">
                <input
                  v-model="quickTriggerReleaseNumMM"
                  maxlength="8"
                  @blur="travelInputOnBlur($event, 'quickTriggerReleaseNumMM')"
                  @input="travelInputOnInput($event, 'quickTriggerReleaseNumMM')"
                  @keydown.enter="($event.target as HTMLInputElement).blur()"
                />mm
              </div>
            </div>
          </div>

          <!-- Bar 3: RT Trigger (Green) -->
          <div class="mgx_bar_item green" v-if="!specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)" @mouseenter="currentHoveredKey = 'quickTriggerPressNum'">
            <div v-if="magnetSet.selectedKeys.value.length == 0" class="progress_overlay" @mousedown="selectCheck(true)" style="position: absolute; inset: 0; z-index: 100; cursor: pointer"></div>
            <div class="visual_wrapper">
              <div class="bar_track">
                <div
                  class="bar_fill green"
                  :style="{
                    height: quickTriggerPressNum > 0 ? getAdaptiveFillHeight(quickTriggerPressNum, getBoundary('rtPress', 'min'), getBoundary('rtPress', 'max')) : '0',
                  }"
                ></div>
              </div>
              <input
                v-model.number="quickTriggerPressNum"
                class="trip_range green_thumb"
                type="range"
                style="transform: translate(-50%, -50%) rotate(90deg)"
                :min="getBoundary('rtPress', 'min')"
                :step="getBoundary('rtPress', 'step')"
                :max="getBoundary('rtPress', 'max')"
                @wheel="wheelEvent($event, 'quickTriggerPressNum')"
              />
            </div>
            <div class="bar_label_group">
              <div class="bar_label">{{ $t('magnet_quick_trigger_sensitivity') }}</div>
              <div class="bar_sub_label">
                <input v-model="quickTriggerPressNumMM" maxlength="8" @blur="travelInputOnBlur($event, 'quickTriggerPressNumMM')" @input="travelInputOnInput($event, 'quickTriggerPressNumMM')" @keydown.enter="($event.target as HTMLInputElement).blur()" />mm
              </div>
            </div>
          </div>

          <!-- Bar 4: Deadzone (Purple) -->
          <mgx_dead_zone
            v-if="isSupportDeadZone"
            :isSupportSingleKeyDeadZone="IsSupportSingleKeyDeadZone"
            :isSupportTopDeadZone="isSupportTopDeadZone"
            :isSupportBottomDeadZone="isSupportBottomDeadZone"
            :isEnabled="deadZoneEnabled"
            :step="deadZoneStep"
            :travelConfig="travelconfig"
            @selectCheck="selectCheck(true)"
            @mouseEnter="currentHoveredKey = 'deadZone'"
            @change="handleDeadZoneChange"
          />
        </div>

        <div class="mgx_stats_panel">
          <div class="stats_group">
            <!-- Trigger Card -->
            <div class="feature_card orange" :class="{ active: currentHoveredKey === 'pressNum' }" @mouseenter="currentHoveredKey = 'pressNum'">
              <div class="card_top">
                <div class="info">
                  <span class="dot orange"></span>
                  <span class="label">{{ $t('magnet_set_trigger_trip') }}</span>
                  <div class="tip_trigger">
                    <SvgAsset :content="mgxFeatureTipSvg" />
                    <div class="feature_tip_bubble">{{ $t('magnet_set_trigger_trip_desc') }}</div>
                  </div>
                </div>
              </div>
              <div class="card_body" style="position: relative">
                <div v-if="magnetSet.selectedKeys.value.length == 0" class="progress_overlay" @mousedown="selectCheck(true)" style="position: absolute; inset: 0; z-index: 100; cursor: pointer"></div>
                <span class="value orange">
                  <input v-model="pressNumMM" maxlength="8" @blur="travelInputOnBlur($event, 'pressNumMM')" @input="travelInputOnInput($event, 'pressNumMM')" @keydown.enter="($event.target as HTMLInputElement).blur()" />
                  <small>mm</small>
                </span>
              </div>
            </div>

            <!-- RT Reset Card -->
            <div
              v-if="!specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)"
              class="feature_card blue"
              :class="{ active: currentHoveredKey === 'quickTriggerReleaseNum', disabled: quickTriggerReleaseNum == 0 }"
              @mouseenter="currentHoveredKey = 'quickTriggerReleaseNum'"
            >
              <div class="card_top">
                <div class="info">
                  <span class="dot blue"></span>
                  <span class="label">{{ $t('magnet_quick_reset_sensitivity') }}</span>
                  <img v-if="isShowMoreGroupBottomTravelTip && isSupportKeyGroupSettings" src="../../assets/img/red_notice_icon.svg" style="width: 14px; height: 14px; margin-left: 4px" />
                  <div class="tip_trigger">
                    <SvgAsset :content="mgxFeatureTipSvg" />
                    <div class="feature_tip_bubble">{{ $t('magnet_quick_trigger_desc') }}</div>
                  </div>
                </div>
                <cswitch :width="32" :height="18" :checked="quickTriggerReleaseNum > 0" :click="enableQuickTriggerRelease" />
              </div>
              <div
                class="card_body"
                :style="{
                  opacity: quickTriggerReleaseNum > 0 ? 1 : 0,
                  visibility: quickTriggerReleaseNum > 0 ? 'visible' : 'hidden',
                  pointerEvents: quickTriggerReleaseNum > 0 ? 'auto' : 'none',
                  height: '34px',
                  overflow: 'hidden',
                  position: 'relative',
                }"
              >
                <div v-if="magnetSet.selectedKeys.value.length == 0" class="progress_overlay" @mousedown="selectCheck(true)" style="position: absolute; inset: 0; z-index: 100; cursor: pointer"></div>
                <span class="value blue">
                  <input
                    v-model="quickTriggerReleaseNumMM"
                    maxlength="8"
                    @blur="travelInputOnBlur($event, 'quickTriggerReleaseNumMM')"
                    @input="travelInputOnInput($event, 'quickTriggerReleaseNumMM')"
                    @keydown.enter="($event.target as HTMLInputElement).blur()"
                  />
                  <small>mm</small>
                </span>
              </div>
            </div>

            <!-- RT Trigger Card -->
            <div
              v-if="!specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)"
              class="feature_card green"
              :class="{ active: currentHoveredKey === 'quickTriggerPressNum', disabled: quickTriggerPressNum == 0 }"
              @mouseenter="currentHoveredKey = 'quickTriggerPressNum'"
            >
              <div class="card_top">
                <div class="info">
                  <span class="dot green"></span>
                  <span class="label">{{ $t('magnet_quick_trigger_sensitivity') }}</span>
                  <div class="tip_trigger">
                    <SvgAsset :content="mgxFeatureTipSvg" />
                    <div class="feature_tip_bubble">{{ $t('magnet_quick_trigger_desc') }}</div>
                  </div>
                </div>
                <cswitch :width="32" :height="18" :checked="quickTriggerPressNum > 0" :click="enableQuickTriggerPress" />
              </div>
              <div
                class="card_body"
                :style="{
                  opacity: quickTriggerPressNum > 0 ? 1 : 0,
                  visibility: quickTriggerPressNum > 0 ? 'visible' : 'hidden',
                  pointerEvents: quickTriggerPressNum > 0 ? 'auto' : 'none',
                  height: '34px',
                  overflow: 'hidden',
                  position: 'relative',
                }"
              >
                <div v-if="magnetSet.selectedKeys.value.length == 0" class="progress_overlay" @mousedown="selectCheck(true)" style="position: absolute; inset: 0; z-index: 100; cursor: pointer"></div>
                <span class="value green">
                  <input v-model="quickTriggerPressNumMM" maxlength="8" @blur="travelInputOnBlur($event, 'quickTriggerPressNumMM')" @input="travelInputOnInput($event, 'quickTriggerPressNumMM')" @keydown.enter="($event.target as HTMLInputElement).blur()" />
                  <small>mm</small>
                </span>
              </div>
            </div>

            <!-- Deadzone Card -->
            <div v-if="isSupportDeadZone" class="feature_card purple" :class="{ active: currentHoveredKey === 'deadZone' }" @mouseenter="currentHoveredKey = 'deadZone'">
              <div class="card_top">
                <div class="info">
                  <span class="dot purple"></span>
                  <span class="label">{{ IsSupportSingleKeyDeadZone ? $t('magnet_dead_zone_single_key') : $t('magnet_dead_zone_global') }}</span>
                  <div class="tip_trigger" v-if="IsSupportSingleKeyDeadZone || isShowDeadZoneStabilityTip">
                    <SvgAsset :content="mgxFeatureTipSvg" />
                    <div class="feature_tip_bubble">
                      {{ IsSupportSingleKeyDeadZone ? $t('single_key_dead_zone_tip') : $t('dead_zone_tip') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card_body" style="overflow: hidden; position: relative">
                <div
                  v-if="IsSupportSingleKeyDeadZone && magnetSet.isShowSingleKeyDeadZone.value && magnetSet.selectedKeys.value.length == 0"
                  class="progress_overlay"
                  @mousedown="selectCheck(true)"
                  style="position: absolute; inset: 0; z-index: 100; cursor: pointer"
                ></div>
                <div class="value purple">
                  <template v-if="isSupportTopDeadZone">
                    <input v-model="deadZoneTopMM" maxlength="8" @blur="travelInputOnBlur($event, 'deadZoneTopMM')" @input="travelInputOnInput($event, 'deadZoneTopMM')" @keydown.enter="($event.target as HTMLInputElement).blur()" />
                  </template>
                  <template v-if="isSupportBottomDeadZone">
                    <span v-if="isSupportTopDeadZone" class="separator">|</span>
                    <input v-model="deadZoneBottomMM" maxlength="8" @blur="travelInputOnBlur($event, 'deadZoneBottomMM')" @input="travelInputOnInput($event, 'deadZoneBottomMM')" @keydown.enter="($event.target as HTMLInputElement).blur()" />
                  </template>
                  <small>mm</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <IMCVue v-if="currentMgxMode == MgxMode.IMC" @open-video="showVideo = true" />
      <MgxDaily v-if="currentMgxMode == MgxMode.Daily"></MgxDaily>
    </div>
  </div>
  <Teleport to="body">
    <IMC_video v-if="showVideo" @close="showVideo = false" />
  </Teleport>
  <Teleport to="body">
    <div v-if="isCalibrationTooltipVisible" class="mgx_tip_bubble_teleport" :style="calibrationTooltipStyle">
      {{ $t('keyboard_calibration_notice_desc') }}
    </div>
  </Teleport>
</template>
<script lang="ts">
import { ref } from 'vue'
export let show_mgx_introduce = ref(false)
</script>

<script lang="ts" setup>
import { computed, onMounted, onUnmounted, Ref, toRefs, watch } from 'vue'
import { MagnetDynamicReport, PostMagnetSetKeyInfo, magnetSet } from '@/service/driver/magnet_set'
import { magnetSetKeyGroup } from '@/service/driver/magnet_key_group'
import { DialogType, enableDialog } from '../cdialog/dialog'
import { calibrationHandler } from '@/service/driver/calibration_set'
import { DeviceManager, DeviceProtocol } from '@/service/device'
import i18n from '@/languages/i18n'
import Cswitch from '../cswitch/cswitch.vue'
import { openExternalLink } from '@/tool/utility'
import { configSet } from '@/service/driver/config_set'
import { deviceQuickTriggerTravel, getTravelStep, travelConfig, travelFe87V2FWGT212Config } from '@/define/magnet_travel'
import firmware from '@/upgrade/firmware'
import { DriverService } from '@/service/driver/driver'
import { DriverSocketMsgType } from '@libs/types/message'
import { DevicePid } from '@/define/define'
import { specialCheck, speciaBehiver } from '@/define/limit'
import { KeyGroup } from '@libs/types/enum'
import mgx_key_group from './mgx_key_group.vue'
import { getCurrentDeviceMagnetKKs } from '@/profiles/selector'

import { specialCheckCurrent } from '@/define/limit'
import { getBrandWebsite } from '@/brand/brand'
import { PostMagnetSetKeyDeadZone } from '@libs/types/response'
import { alignToMultiple, delay } from '@libs/utils/tools'
import { adjustTravel } from '@/device_tweaks/travel'
import IMCSwitch, { currentMgxMode, IMCSwitchState, isFE87V2IMCNH, MgxMode } from './IMC_switch.vue'
import IMCVue from './IMC.vue'
import MgxDaily from './mgx_daily.vue'
import IMC_video from './IMC_video.vue'
import mgx_dead_zone from './mgx_dead_zone.vue'
import SvgAsset from '../common/SvgAsset.vue'
import mgxCalibrationSvg from '@/assets/inline-svg/mgx-calibration.svg?raw'
import mgxErrorSvg from '@/assets/inline-svg/action-error.svg?raw'
import mgxFeatureTipSvg from '@/assets/inline-svg/feature-tip.svg?raw'
import mgxHelpCircleSvg from '@/assets/inline-svg/mgx-help-circle.svg?raw'
import mgxInfoCircleSvg from '@/assets/inline-svg/info-circle.svg?raw'
import mgxLoadingSvg from '@/assets/inline-svg/action-loading.svg?raw'
import mgxResetSvg from '@/assets/inline-svg/action-reset.svg?raw'
import mgxSaveSvg from '@/assets/inline-svg/action-save.svg?raw'
import mgxSelectSwitchSvg from '@/assets/inline-svg/mgx-select-switch.svg?raw'
import mgxSuccessSvg from '@/assets/inline-svg/action-success.svg?raw'
import mgxTesterSvg from '@/assets/inline-svg/mgx-tester.svg?raw'
import { isShowTester } from '../tester/tester.vue'

import { Fe87v2DeviceList } from '@/define/device_vendor'
import { formatNumber, formatToFixedDecimal, textInputAllowOnlyNumbers } from '@libs/utils/input'

const setkeyDisable = ref(false)
const saveStatus = ref('idle')
const resetStatus = ref('idle')
const showVideo = ref(false)
const calibrationTipButtonRef = ref<HTMLDivElement | null>(null)
const isCalibrationTooltipVisible = ref(false)
const calibrationTooltipStyle = ref<Record<string, string>>({})
const { t } = i18n.global

const updateCalibrationTooltipPosition = () => {
  const buttonElement = calibrationTipButtonRef.value
  if (!buttonElement) {
    return
  }

  const rect = buttonElement.getBoundingClientRect()
  calibrationTooltipStyle.value = {
    left: `${rect.left + rect.width / 2}px`,
    top: `${rect.top - 12}px`,
  }
}

const showCalibrationTooltip = () => {
  updateCalibrationTooltipPosition()
  isCalibrationTooltipVisible.value = true
}

const hideCalibrationTooltip = () => {
  isCalibrationTooltipVisible.value = false
}

const calibrationEvent = async () => {
  // magnetSet.keysInfoReading.value 为true时，表示正在获取行程信息，等待获取完成，在进行校准，否则会导致数据发送异常
  while (magnetSet.keysInfoReading.value) {
    await delay(100)
  }
  calibrationHandler.showCalibrationPageByVendor()
}

const isShowCalibration = computed(() => {
  const check = DeviceManager.instance.state.currentPid != DevicePid.None
  if (specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)) {
    if (isFE87V2IMCNH()) {
      return false
    }
    return check && !IMCSwitchState.value
  }
  return check
})

const deviceQuickTriggerTravelData = deviceQuickTriggerTravel(DeviceManager.instance.state.currentPid)
const travel = ref(0)
let travelconfig = travelConfig(DeviceManager.instance.state.currentPid)
const isShowDeadZone = ref(false)
const travelStep = ref(100)

const pressDescRef: Ref<HTMLDivElement | null> = ref(null)
const quickTriggerPressDescRef: Ref<HTMLDivElement | null> = ref(null)
const quickTriggerReleaseDescRef: Ref<HTMLDivElement | null> = ref(null)
const deadZoneRef: Ref<HTMLDivElement | null> = ref(null)

const currentHoveredKey = ref('pressNum')
const hoverTitle = computed(() => {
  switch (currentHoveredKey.value) {
    case 'pressNum':
      return t('magnet_set_trigger_trip')
    case 'quickTriggerReleaseNum':
      return t('magnet_quick_reset_sensitivity')
    case 'quickTriggerPressNum':
      return t('magnet_quick_trigger_sensitivity')
    case 'deadZone':
      return IsSupportSingleKeyDeadZone.value ? t('magnet_dead_zone') : t('magnet_dead_zone_all_keys')
    default:
      return t('magnet_set_trigger_trip')
  }
})

const hoverValue = computed({
  get: () => {
    switch (currentHoveredKey.value) {
      case 'pressNum':
        return pressNumMM.value
      case 'quickTriggerReleaseNum':
        return quickTriggerReleaseNumMM.value
      case 'quickTriggerPressNum':
        return quickTriggerPressNumMM.value
      case 'deadZone':
        return (magnetSet.newDeadZone.Top / 1000).toFixed(2)
      default:
        return pressNumMM.value
    }
  },
  set: (val) => {
    // We handle updates via travelInputOnBlur usually
  },
})

const initShowDeadZone = async () => {
  const fwVersionIs102 = await firmware.fwVersionGreaterThanOrEqual('1.0.2', firmware.fwVersionDvs1)
  const fwVersionIs100 = await firmware.fwVersionGreaterThanOrEqual('1.0.0', firmware.fwVersionDvs2)
  const fwVersionIs20250326 = await firmware.versionIs20250326()
  if (specialCheck(speciaBehiver.SupportSetDeadZone, DeviceManager.instance.state.currentPid) && (fwVersionIs102 || fwVersionIs100 || fwVersionIs20250326)) {
    isShowDeadZone.value = true
  }
}
const deadZoneStep: Ref<number> = ref(0)

const fwVersionComputedDeadZoneStep = async () => {
  if (travelconfig.deadZoneStep) {
    return travelconfig.deadZoneStep
  }
  return travelconfig.maxTravel / travelStep.value
}

const initStep = async () => {
  travelStep.value = await getTravelStep()
}

const IsSupportSingleKeyDeadZone = ref(false)
const isSupportKeyGroupSettings = ref(false)

const isSupportDeadZone = computed(() => IsSupportSingleKeyDeadZone.value || isShowDeadZone.value)

const isSupportTopDeadZone = computed(() => isSupportDeadZone.value)
const isSupportBottomDeadZone = computed(() => !specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix))

const deadZoneEnabled = computed(() => {
  if (!isSupportDeadZone.value) return false
  return true
})

const deadZoneChecked = computed(() => (IsSupportSingleKeyDeadZone.value ? magnetSet.isShowSingleKeyDeadZone.value : true))

const handleDeadZoneSwitch = () => {
  magnetSet.enableSingleKeyDeadZone()
  // 切换时，如果当前没有选中按键，数据会回落到 globalDeadZone
}

const isShowDeadZoneStabilityTip = computed(() => {
  if (!isSupportDeadZone.value) return false
  if (!isShowDefaultGroupDeadZoneTip.value) return false

  const unit = travelconfig.unit
  const topLow = isSupportTopDeadZone.value && magnetSet.newDeadZone.Top < 0.2 * unit
  const bottomLow = isSupportBottomDeadZone.value && magnetSet.newDeadZone.Bottom < 0.2 * unit

  return topLow || bottomLow
})

onMounted(async () => {
  window.addEventListener('resize', hideCalibrationTooltip)
  window.addEventListener('scroll', hideCalibrationTooltip, true)
  magnetSet.dataCleared.value = false
  await initStep()
  await initFe87V2TravelConfig()
  await initShowDeadZone()
  IsSupportSingleKeyDeadZone.value = await magnetSet.fwIsSupportSingleKeyDeadZone()
  deadZoneStep.value = await fwVersionComputedDeadZoneStep()
  if (DeviceManager.instance.state.driverProtocol == DeviceProtocol.dll_exe) {
    DriverService.instance.setHandler(DriverSocketMsgType.MSMagnetDynamicKey, (res: MagnetDynamicReport[]) => {
      if (res.length > 0) {
        travel.value = res[0].Value
      }
    })
    magnetSet.watchKeysTrip()
    magnetSet.handelKeysInfo()
  } else {
    await magnetSet.getKeysInfo()
    if (IsSupportSingleKeyDeadZone.value) {
      await magnetSet.getKeysDeadZone()
    } else {
      await magnetSet.getDeadZone()
      if (magnetSet.deadZone.value) {
        magnetSet.newDeadZone.Top = magnetSet.deadZone.value[0]
        magnetSet.newDeadZone.Bottom = magnetSet.deadZone.value[1]
      }
    }
  }
  initTravelInputValue()
  initShowKeyGroupSettings()
  if (isSupportKeyGroupSettings.value) {
    magnetSetKeyGroup.getKeysGroupInfo()
  }
  initCurrentMode()
})

const initCurrentMode = () => {
  if (IMCSwitchState.value) {
    currentMgxMode.value = MgxMode.IMC
  } else {
    if (isFE87V2IMCNH()) {
      currentMgxMode.value = MgxMode.Daily
    } else {
      currentMgxMode.value = MgxMode.MGX
    }
  }
}

const initFe87V2TravelConfig = async () => {
  if (specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)) {
    const fwGT212 = await firmware.fwVersionGreaterThanOrEqual('2.1.2', [...Fe87v2DeviceList])
    if (fwGT212) {
      travelconfig = travelFe87V2FWGT212Config
    }
  }
}

const initShowKeyGroupSettings = () => {
  if (specialCheckCurrent(speciaBehiver.DeviceOfRoyuan)) {
    isSupportKeyGroupSettings.value = true
  }
  if (specialCheck(speciaBehiver.SupportAxisKeysGroup, DeviceManager.instance.state.currentPid) && IsSupportSingleKeyDeadZone.value) {
    isSupportKeyGroupSettings.value = true
  }
}

onUnmounted(() => {
  window.removeEventListener('resize', hideCalibrationTooltip)
  window.removeEventListener('scroll', hideCalibrationTooltip, true)
  magnetSet.clearMagnetSet(null)
  IsSupportSingleKeyDeadZone.value = false
  IMCSwitchState.value = false
  currentMgxMode.value = MgxMode.MGX
})

const { pressNum, quickTriggerPressNum, quickTriggerReleaseNum } = toRefs(magnetSet.magnetData)

const getMinTravel = () => {
  if (travelconfig.minTravel) {
    return travelconfig.minTravel
  }
  return 0
}

const selectSwitch = () => {
  magnetSetKeyGroup.state.isShowSetKeyGroup = !magnetSetKeyGroup.state.isShowSetKeyGroup
  magnetSetKeyGroup.state.keysGroupType = KeyGroup.none
  magnetSet.selectedKeys.value = []
}

const reset = (all: boolean) => {
  if (setkeyDisable.value || resetStatus.value !== 'idle') {
    return
  }
  if (all) {
    pressNum.value = travelconfig.defaultTravel
    quickTriggerPressNum.value = 0
    quickTriggerReleaseNum.value = 0
    resetStatus.value = 'loading'
    saveChange(getCurrentDeviceMagnetKKs.value, true)
  } else {
    if (!selectCheck()) {
      return
    }
    resetStatus.value = 'loading'
    saveChange(magnetSet.selectedKeys.value, true)
  }
}

const selectCheck = (quiet = false) => {
  if (magnetSet.selectedKeys.value.length == 0) {
    if (quiet) {
      // 触发虚拟键盘处的“小手”及气泡提示
      if ((magnetSet as any)._showGuideFlag) (magnetSet as any)._showGuideFlag.value = true
    } else {
      enableDialog(t('please_select_key'), DialogType.notice, false)
    }
    return false
  }
  return true
}

const shouldSaveDeadZoneGlobally = (keys: number[] = []) => {
  if (!IsSupportSingleKeyDeadZone.value) {
    return true
  }

  if (keys.length > 0) {
    return false
  }

  return !magnetSet.isShowSingleKeyDeadZone.value
}

const save = () => {
  if (setkeyDisable.value || saveStatus.value !== 'idle') {
    return
  }
  const isGlobalDeadZone = shouldSaveDeadZoneGlobally(magnetSet.selectedKeys.value)
  if (isGlobalDeadZone && magnetSet.selectedKeys.value.length === 0) {
    saveStatus.value = 'loading'
    saveChange([])
    return
  }

  if (!selectCheck(true)) {
    return
  }
  saveStatus.value = 'loading'
  saveChange(magnetSet.selectedKeys.value)
}

const enableQuickTriggerPress = () => {
  if (!selectCheck(true)) {
    return
  }
  if (quickTriggerPressNum.value > 0) {
    closeQuickTrigger(false)
  } else {
    setQuickTrigger(false)
  }
}

const enableQuickTriggerRelease = () => {
  if (!selectCheck(true)) {
    return
  }
  if (quickTriggerReleaseNum.value > 0) {
    closeQuickTrigger(true)
  } else {
    setQuickTrigger(true)
  }
}

const openDeadZone = () => {
  if (!magnetSet.isShowSingleKeyDeadZone.value) {
    magnetSet.isShowSingleKeyDeadZone.value = true
    localStorage.setItem('isShowSingleKeyDeadZone', 'true')
  }
}

// rt 的最大行程与TriggerRelease的最大行程相差的值
const calculateTravelDifference = computed(() => travelconfig.maxTravel - getBoundary('rtRelease', 'max'))
// 计算TriggerRelease的最大行程
const computedQuickTriggerReleaseMaxTravel = computed(() => {
  if (calculateTravelDifference.value <= pressNum.value) {
    return getBoundary('rtRelease', 'max') - (pressNum.value - calculateTravelDifference.value)
  }
  return getBoundary('rtRelease', 'max')
})

const changePressNum = () => {
  const last = getBoundary('rtRelease', 'max') - (pressNum.value - calculateTravelDifference.value)
  if (last < quickTriggerReleaseNum.value) {
    quickTriggerReleaseNum.value = last
  }
  if (quickTriggerReleaseNum.value == 0) {
    closeQuickTrigger(false)
  }
}

watch(
  () => magnetSet.newDeadZone.Top,
  (val) => {
    if (specialCheckCurrent(speciaBehiver.DeviceOfRoyuan)) {
      if (magnetSet.newDeadZone.Bottom !== val) {
        magnetSet.newDeadZone.Bottom = val
      }
    }
    if (magnetSet.newDeadZone.Top > maxTopDeadZone.value) {
      magnetSet.newDeadZone.Top = Math.floor(maxTopDeadZone.value)
    }
    if (magnetSet.newDeadZone.Top < minTopDeadZone.value) {
      magnetSet.newDeadZone.Top = Math.floor(minTopDeadZone.value)
    }
    deadZoneTopMM.value = formatNumber(magnetSet.newDeadZone.Top / travelconfig.unit, travelconfig.decimalPlaces)
  },
)

watch(
  () => magnetSet.newDeadZone.Bottom,
  (val) => {
    if (specialCheckCurrent(speciaBehiver.DeviceOfRoyuan)) {
      if (magnetSet.newDeadZone.Top !== val) {
        magnetSet.newDeadZone.Top = val
      }
    }
    if (magnetSet.newDeadZone.Bottom > maxBottomDeadZone.value) {
      magnetSet.newDeadZone.Bottom = Math.floor(maxBottomDeadZone.value)
    }
    if (magnetSet.newDeadZone.Bottom < minBottomDeadZone.value) {
      magnetSet.newDeadZone.Bottom = Math.floor(minBottomDeadZone.value)
    }
    deadZoneBottomMM.value = formatNumber(magnetSet.newDeadZone.Bottom / travelconfig.unit, travelconfig.decimalPlaces)
  },
)

watch(pressNum, (value) => {
  pressNumMM.value = formatNumber(value / travelconfig.unit, travelconfig.decimalPlaces)
  if (pressNum.value == travelconfig.maxTravel) {
    quickTriggerReleaseNum.value = 0
  }
})

watch(quickTriggerPressNum, (value) => {
  quickTriggerPressNumMM.value = formatNumber(value / travelconfig.unit, travelconfig.decimalPlaces)
  if (value > 0) {
    setQuickTrigger(false)
  } else {
    closeQuickTrigger(false)
  }
})

watch(quickTriggerReleaseNum, (value) => {
  quickTriggerReleaseNumMM.value = formatNumber(value / travelconfig.unit, travelconfig.decimalPlaces)
  if (value > 0) {
    setQuickTrigger(true)
  } else {
    closeQuickTrigger(true)
  }
})

const setQuickTrigger = (isReleaseTrigger: boolean) => {
  if (isReleaseTrigger) {
    quickTriggerReleaseNum.value = quickTriggerReleaseNum.value == 0 ? deviceQuickTriggerTravelData.Release : quickTriggerReleaseNum.value
    if (deviceQuickTriggerTravelData.IsEnableBoth) {
      quickTriggerPressNum.value = quickTriggerPressNum.value == 0 ? deviceQuickTriggerTravelData.Press : quickTriggerPressNum.value
    }
  } else {
    quickTriggerReleaseNum.value = quickTriggerReleaseNum.value == 0 ? deviceQuickTriggerTravelData.Release : quickTriggerReleaseNum.value
    quickTriggerPressNum.value = quickTriggerPressNum.value == 0 ? deviceQuickTriggerTravelData.Press : quickTriggerPressNum.value
  }
  changePressNum()
  quickTriggerReleaseNumMM.value = formatNumber(quickTriggerReleaseNum.value / travelconfig.unit, travelconfig.decimalPlaces)
  quickTriggerPressNumMM.value = formatNumber(quickTriggerPressNum.value / travelconfig.unit, travelconfig.decimalPlaces)
}

const closeQuickTrigger = (isReleaseTrigger: boolean) => {
  if (isReleaseTrigger) {
    quickTriggerPressNum.value = 0
    quickTriggerReleaseNum.value = 0
  } else {
    if (deviceQuickTriggerTravelData.IsEnableBoth) {
      quickTriggerPressNum.value = 0
      quickTriggerReleaseNum.value = 0
    } else {
      quickTriggerPressNum.value = 0
    }
  }
  quickTriggerReleaseNumMM.value = formatNumber(quickTriggerReleaseNum.value / travelconfig.unit, travelconfig.decimalPlaces)
  quickTriggerPressNumMM.value = formatNumber(quickTriggerPressNum.value / travelconfig.unit, travelconfig.decimalPlaces)
}

const handleDeadZoneChange = () => {
  if (IsSupportSingleKeyDeadZone.value && magnetSet.isShowSingleKeyDeadZone.value) {
    if (magnetSet.selectedKeys.value.length === 0) {
      selectCheck()
    }
  }
}

const saveChange = async (keys: number[] = [], isReset: boolean = false) => {
  const par = {
    Keys: keys,
    PressNum: isReset ? travelconfig.defaultTravel : Number(pressNum.value),
    ReleaseNum: isReset ? travelconfig.defaultTravel : Number(pressNum.value),
    QuickTriggerReleaseNum: isReset ? 0 : Number(quickTriggerReleaseNum.value),
    QuickTriggerPressNum: Number(quickTriggerReleaseNum.value) > 0 && !isReset ? Number(quickTriggerPressNum.value) : 0,
  } as PostMagnetSetKeyInfo

  const data = adjustTravel(par)

  const changeTravelPromise = keys.length > 0 ? magnetSet.setKeyInfo(data) : Promise.resolve()

  const isGlobalDeadZone = shouldSaveDeadZoneGlobally(keys)
  let deadZoneKeys = keys
  if (isGlobalDeadZone && IsSupportSingleKeyDeadZone.value) {
    deadZoneKeys = getCurrentDeviceMagnetKKs.value
  }

  const changeDeadZonePromise = changeSingleKeyDeadZone(deadZoneKeys, isReset)

  setkeyDisable.value = true
  Promise.all([changeTravelPromise, changeDeadZonePromise])
    .then(async (_) => {
      if (specialCheckCurrent(speciaBehiver.DeviceOfRoyuan)) {
        //延迟检�?
        await delay(500)
      }
      //设置成功后在读取一次行程
      await magnetSet.getKeysInfo()
      if (keys.length > 0) {
        magnetSet.changelist(data)
      }
      if (isGlobalDeadZone) {
        magnetSet.deadZone.value = [Number(magnetSet.newDeadZone.Top), Number(magnetSet.newDeadZone.Bottom)]
      }
      if (IsSupportSingleKeyDeadZone.value) {
        await magnetSet.getKeysDeadZone()
      } else {
        if (isShowDeadZone.value) {
          await magnetSet.getDeadZone()
          if (magnetSet.deadZone.value) {
            magnetSet.newDeadZone.Top = magnetSet.deadZone.value[0]
            magnetSet.newDeadZone.Bottom = magnetSet.deadZone.value[1]
          }
        }
      }
      initTravelInputValue()
      if (isReset) {
        magnetSet.changeViewByAddKeys(keys)
      }
      setkeyDisable.value = false

      if (isReset) {
        resetStatus.value = 'success'
        setTimeout(() => {
          resetStatus.value = 'idle'
        }, 1000)
      } else {
        saveStatus.value = 'success'
        setTimeout(() => {
          saveStatus.value = 'idle'
        }, 1000)
      }
    })
    .catch((_) => {
      setkeyDisable.value = false
      if (isReset) {
        resetStatus.value = 'error'
        setTimeout(() => {
          resetStatus.value = 'idle'
        }, 1000)
      } else {
        saveStatus.value = 'error'
        setTimeout(() => {
          saveStatus.value = 'idle'
        }, 1000)
      }
    })
}

const changeSingleKeyDeadZone = async (keys: number[], isReset: boolean = false) => {
  if (!IsSupportSingleKeyDeadZone.value) {
    if (isShowDeadZone.value) {
      const top = isReset ? travelconfig.defaultDeadZone.top : Number(magnetSet.newDeadZone.Top)
      const bottom = isReset ? travelconfig.defaultDeadZone.bottom : Number(magnetSet.newDeadZone.Bottom)
      return magnetSet.setDeadZone([top, bottom])
    }
    return Promise.resolve()
  }

  const data = {
    Keys: keys,
    Top: isReset ? travelconfig.defaultDeadZone.top : Number(magnetSet.newDeadZone.Top),
    Bottom: isReset ? travelconfig.defaultDeadZone.bottom : Number(magnetSet.newDeadZone.Bottom),
  } as PostMagnetSetKeyDeadZone
  return magnetSet.setKeysDeadZone(data)
}

const { currentPid } = toRefs(DeviceManager.instance.state)
watch(currentPid, () => {
  magnetSet.clearMagnetSet(null)
})
const open = async () => {
  const host = await getBrandWebsite()
  openExternalLink(`https://${host}/magnet/introduce`)
}

watch(configSet.currentConfig, () => {
  magnetSet.handelKeysInfo()
})

const changeDeadZone = async (value: number[]) => {
  magnetSet.deadZone.value = value
  // 同步到 newDeadZone 以便 UI 实时更新
  magnetSet.newDeadZone.Top = value[0]
  magnetSet.newDeadZone.Bottom = value[1]

  let resPromise: Promise<any> | null = null
  if (IsSupportSingleKeyDeadZone.value) {
    resPromise = changeSingleKeyDeadZone(getCurrentDeviceMagnetKKs.value)
  } else {
    resPromise = magnetSet.setDeadZone(magnetSet.deadZone.value)
  }
  resPromise
    .then((_) => {
      enableDialog(t('setting_success'))
    })
    .catch((_) => {
      enableDialog(t('setting_failed'))
    })
}
const areAllKeysInSameGroup = (): boolean => {
  for (const key of magnetSet.selectedKeys.value) {
    let belongsToTianqing = false
    let belongsToZixing = false

    for (const [keyGroup, kks] of magnetSetKeyGroup.state.keysGroup) {
      if (kks.includes(key)) {
        if (keyGroup === KeyGroup.tianqing) {
          belongsToTianqing = true
        } else if (keyGroup === KeyGroup.zixing) {
          belongsToZixing = true
        }
      }
    }
    // 既不属于天青也不属于紫星
    if (belongsToTianqing == false && belongsToZixing == false) {
      return false
    }
  }
  return true
}

// 蓝条的提示文案（为确保设备稳定，建议行程设置�?.20mm以上），什么情况下不显示？

// 有分组，并且分组是默认分�?// 蓝条的行�?> 0.2 情况下不显示�?// 选中按键里面，全部都是天青或者全部都是紫星的情况下不显示
// 其他情况都显�?
const isShowMoreGroupBottomTravelTip = computed(() => {
  if (specialCheckCurrent(speciaBehiver.DevicesOfWitmod) || specialCheckCurrent(speciaBehiver.DevicesOfJingtai_V2)) {
    return false
  }
  if (specialCheckCurrent(speciaBehiver.DevicesOfHuoChaiRen)) {
    return false
  }
  if (IsSupportSingleKeyDeadZone.value == false) {
    return false
  }

  // 有分组，并且分组是默认分组
  if (magnetSetKeyGroup.state.keysGroup.size <= 1 && (magnetSetKeyGroup.state.keysGroupType == magnetSetKeyGroup.state.defaultKeysGroup || magnetSetKeyGroup.state.keysGroupType == KeyGroup.none)) {
    return false
  }

  if (quickTriggerReleaseNum.value <= 0) {
    return false
  }

  if (quickTriggerReleaseNum.value / travelconfig.unit > 0.2) {
    return false
  }

  if (areAllKeysInSameGroup()) {
    return false
  }

  return true
})

// 非磁珀轴以外的分组
const isShowOtherGroupDeadZoneTip = computed(() => {
  if (IsSupportSingleKeyDeadZone.value == false) {
    return false
  }
  if (magnetSetKeyGroup.state.keysGroup.size > 1) {
    for (let [keyGroupType, keys] of magnetSetKeyGroup.state.keysGroup) {
      if ((keyGroupType == KeyGroup.tianqing || keyGroupType == KeyGroup.zixing) && keys.length > 0) {
        return true
      }
    }
  }
  return false
})

// 默认的分组
const isShowDefaultGroupDeadZoneTip = computed(() => {
  if (magnetSetKeyGroup.state.keysGroup.size == 0) {
    return true
  }
  return false
})

const isShowDeviceBottomDeadZoneTip = computed(() => {
  return !specialCheckCurrent(speciaBehiver.DevicesSwitchOfJingtaiTianqing) && !specialCheckCurrent(speciaBehiver.DevicesSwitchOfJingtaiZixin)
})

// --- Travel Boundary Getters ---
const getBoundary = (type: 'press' | 'rtPress' | 'rtRelease', boundary: 'min' | 'max' | 'step') => {
  const config = travelconfig
  const defaults = {
    press: { min: config.minTravel || config.maxTravel / travelStep.value, max: config.maxTravel, step: travelStep.value },
    rtPress: {
      min: config.minTravel || (config.quickTriggerPressMaxTravel || config.maxTravel) / (config.quickTriggerPressStep || config.step),
      max: config.quickTriggerPressMaxTravel || config.maxTravel,
      step: config.quickTriggerPressStep || config.step,
    },
    rtRelease: {
      min: config.minTravel || (config.quickTriggerReleaseMaxTravel || config.maxTravel) / (config.quickTriggerReleaseStep || config.step),
      max: config.quickTriggerReleaseMaxTravel || config.maxTravel,
      step: config.quickTriggerReleaseStep || config.step,
    },
  }
  const item = defaults[type]
  if (boundary === 'step') return item.max / item.step
  return item[boundary]
}

const wheelEvent = (e: WheelEvent, setKey: string) => {
  if (!selectCheck()) return
  e.preventDefault()

  const map = {
    pressNum: { type: 'press', ref: pressNum },
    quickTriggerPressNum: { type: 'rtPress', ref: quickTriggerPressNum },
    quickTriggerReleaseNum: { type: 'rtRelease', ref: quickTriggerReleaseNum },
  } as const

  const config = map[setKey as keyof typeof map]
  if (!config) return

  const step = getBoundary(config.type as any, 'step')
  const delta = e.deltaY > 0 ? (setKey === 'quickTriggerReleaseNum' ? -step : step) : setKey === 'quickTriggerReleaseNum' ? step : -step

  config.ref.value = Math.min(Math.max(Number(config.ref.value) + delta, getBoundary(config.type as any, 'min')), getBoundary(config.type as any, 'max'))

  if (setKey === 'pressNum' && travelconfig.maxTravel - pressNum.value < quickTriggerReleaseNum.value) {
    quickTriggerReleaseNum.value = travelconfig.maxTravel - pressNum.value
  }
}

const handleKeyMouseEnter = (setKey: string) => {
  const refs: Record<string, Ref<HTMLDivElement | null>> = {
    pressNum: pressDescRef,
    quickTriggerPressNum: quickTriggerPressDescRef,
    quickTriggerReleaseNum: quickTriggerReleaseDescRef,
    deadZone: deadZoneRef,
  }
  refs[setKey]?.value?.classList.add(`${setKey}_font_color`)
}
const handleKeyMouseLeave = () => {
  ;[pressDescRef, quickTriggerPressDescRef, quickTriggerReleaseDescRef, deadZoneRef].forEach((r) => {
    if (r.value) r.value.className = r.value.className.replace(/\b\w+_font_color\b/g, '')
  })
}

const tripAllRange = 289

const rtReleaseHeight = computed(() => {
  const ratio = getBoundary('rtRelease', 'max') / travelconfig.maxTravel
  return tripAllRange * ratio
})

const rtReleaseTop = computed(() => {
  return tripAllRange / 2 + (tripAllRange - rtReleaseHeight.value) / 2
})

const rtPressHeight = computed(() => {
  const ratio = getBoundary('rtPress', 'max') / travelconfig.maxTravel
  return tripAllRange * ratio
})

const rtPressTop = computed(() => {
  return tripAllRange / 2 - (tripAllRange - rtReleaseHeight.value) / 2
})

const isShowMgxTravel = computed(() => {
  return !specialCheckCurrent(speciaBehiver.DevicesOfWitmod)
})

const maxTopDeadZone = computed(() => travelconfig.maxTravel)
const minTopDeadZone = computed(() => 0)
const maxBottomDeadZone = computed(() => travelconfig.maxTravel)
const minBottomDeadZone = computed(() => 0)

const pressNumMM = ref('0.000')
const quickTriggerReleaseNumMM = ref('0.000')
const quickTriggerPressNumMM = ref('0.000')
const deadZoneTopMM = ref('0.000')
const deadZoneBottomMM = ref('0.000')

const initTravelInputValue = () => {
  pressNumMM.value = formatNumber(pressNum.value / travelconfig.unit, travelconfig.decimalPlaces)
  quickTriggerReleaseNumMM.value = formatNumber(quickTriggerReleaseNum.value / travelconfig.unit, travelconfig.decimalPlaces)
  quickTriggerPressNumMM.value = formatNumber(quickTriggerPressNum.value / travelconfig.unit, travelconfig.decimalPlaces)
  deadZoneTopMM.value = formatNumber(magnetSet.newDeadZone.Top / travelconfig.unit, travelconfig.decimalPlaces)
  deadZoneBottomMM.value = formatNumber(magnetSet.newDeadZone.Bottom / travelconfig.unit, travelconfig.decimalPlaces)
}

const getRangeValue = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max)
}

const getAdaptiveFillHeight = (value: number, min: number, max: number) => {
  if (value <= 0 || max <= min) {
    return '0'
  }

  const clampedValue = getRangeValue(value, min, max)
  const ratio = (clampedValue - min) / (max - min)
  return `calc(${ratio} * (var(--mgx-track-height) - var(--mgx-thumb-size)) + var(--mgx-thumb-size))`
}

const travelInputOnBlur = (e: Event, key: string) => {
  const target = e.target as HTMLInputElement
  const setValue = formatToFixedDecimal(target, travelconfig.decimalPlaces)
  const setValueUnit = setValue * travelconfig.unit

  if (key === 'pressNumMM') {
    const step = getBoundary('press', 'step')
    const correctionValue = getRangeValue(setValueUnit, getBoundary('press', 'min'), getBoundary('press', 'max'))
    pressNum.value = alignToMultiple(correctionValue, step)
  } else if (key === 'quickTriggerReleaseNumMM' && setValueUnit > 0) {
    const step = getBoundary('rtRelease', 'step')
    const correctionValue = getRangeValue(setValueUnit, getBoundary('rtRelease', 'min'), getBoundary('rtRelease', 'max'))
    quickTriggerReleaseNum.value = alignToMultiple(correctionValue, step)
  } else if (key === 'quickTriggerPressNumMM' && setValueUnit > 0) {
    const step = getBoundary('rtPress', 'step')
    const correctionValue = getRangeValue(setValueUnit, getBoundary('rtPress', 'min'), getBoundary('rtPress', 'max'))
    quickTriggerPressNum.value = alignToMultiple(correctionValue, step)
  } else if (key === 'deadZoneTopMM') {
    const correctionValue = getRangeValue(setValueUnit, minTopDeadZone.value, maxTopDeadZone.value)
    magnetSet.newDeadZone.Top = alignToMultiple(correctionValue, deadZoneStep.value)
  } else if (key === 'deadZoneBottomMM') {
    const correctionValue = getRangeValue(setValueUnit, minBottomDeadZone.value, maxBottomDeadZone.value)
    magnetSet.newDeadZone.Bottom = alignToMultiple(correctionValue, deadZoneStep.value)
  }

  initTravelInputValue()
}

const travelInputOnInput = (e: Event, key: string) => {
  const map: Record<string, number> = {
    pressNumMM: pressNum.value,
    quickTriggerPressNumMM: quickTriggerPressNum.value,
    quickTriggerReleaseNumMM: quickTriggerReleaseNum.value,
    deadZoneTopMM: magnetSet.newDeadZone.Top,
    deadZoneBottomMM: magnetSet.newDeadZone.Bottom,
  }
  const defaultValue = formatNumber(map[key] / travelconfig.unit, travelconfig.decimalPlaces)
  let value = textInputAllowOnlyNumbers(e, defaultValue)

  if (value.length > 8) value = value.slice(0, 8)

  if (key === 'pressNumMM') pressNumMM.value = value
  if (key === 'quickTriggerReleaseNumMM') quickTriggerReleaseNumMM.value = value
  if (key === 'quickTriggerPressNumMM') quickTriggerPressNumMM.value = value
  if (key === 'deadZoneTopMM') deadZoneTopMM.value = value
  if (key === 'deadZoneBottomMM') deadZoneBottomMM.value = value
}
</script>
<style lang="less" scoped src="./mgx_set.less"></style>
